import { Visibility } from "@material-ui/icons";

import "./widgetSm.css";

export default function WidgetSm() {
    return (
        <div className="widgetSm">
            <span className="widgetSmTitle">New Join Members</span>
            <ul className="widgetSmList">
                <li className="widgetSmListItem">
                    <img src="https://cdn.pixabay.com/photo/2017/04/06/19/34/girl-2209147_960_720.jpg" alt="Jovem mulher" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Katarina Sky</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <Visibility className="widgetSmIcon"/>
                        Display
                    </button>   
                </li>
                <li className="widgetSmListItem">
                    <img src="https://cdn.pixabay.com/photo/2017/04/06/19/34/girl-2209147_960_720.jpg" alt="Jovem mulher" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Katarina Sky</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <Visibility className="widgetSmIcon"/>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://cdn.pixabay.com/photo/2017/04/06/19/34/girl-2209147_960_720.jpg" alt="Jovem mulher" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Katarina Sky</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <Visibility className="widgetSmIcon"/>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://cdn.pixabay.com/photo/2017/04/06/19/34/girl-2209147_960_720.jpg" alt="Jovem mulher" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Katarina Sky</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <Visibility className="widgetSmIcon"/>
                        Display
                    </button>
                </li>
                <li className="widgetSmListItem">
                    <img src="https://cdn.pixabay.com/photo/2017/04/06/19/34/girl-2209147_960_720.jpg" alt="Jovem mulher" className="widgetSmImg" />
                    <div className="widgetSmUser">
                        <span className="widgetSmUsername">Katarina Sky</span>
                        <span className="widgetSmUserTitle">Software Engineer</span>
                    </div>
                    <button className="widgetSmButton">
                        <Visibility className="widgetSmIcon"/>
                        Display
                    </button>
                </li>
            </ul>
        </div>
    )
}
